import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";

import { setEnvIdResolver } from "@/preview-mode/hcic-demo";

import freshpaintReducer from "../reducers";

const reduxMiddleware = compose(
  applyMiddleware(thunk),
  // prettier-ignore
  // @ts-ignore
  window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f,
);

export const store = createStore(freshpaintReducer, reduxMiddleware);
export type StoreState = ReturnType<typeof store.getState>;

// Lets preview mode's non-React code paths (the sidebar store, the
// recommendation-cards handler) read the resolved current env id without
// importing the store, which would create a load-time cycle through the reducer.
setEnvIdResolver(
  () => store.getState().environments.currentEnvironment?.ID ?? null,
);
